import { domReady } from './dom-ready';
export const WEBLAB_IDS = {
  group0: 'WEBLAB_PLACEHOLDER_NAME_GROUP_0',
  group1: 'SP_SERVICES_706592_T1',
  group2: 'SP_SERVICES_764183_T1',
  group3: 'SP_SERVICES_765948_T1',
  group4: 'SP_SERVICES_KATAL_783808_T1',
  group5: 'SP_SERVICES_783812_T1',
  group6: 'SP_SERVICES_KATAL_783813_T1'
};
export const VISUAL_REFRESH_CLASSNAME = 'katal-visual-refresh-2024';
window['KATAL_CONVERT_WEBLAB_META_ELEMENT_EXECUTED'] = false;
const convertWeblabMetaElement = () => {
  const weblabMetaTag = document.head?.querySelector('meta[name="a2z:mons_weblab_treatment"]');
  const weblabs = weblabMetaTag?.content?.split(',') || [];
  if (weblabs.includes('SP_SERVICES_KATAL_902839=T1')) {
    document.body?.classList.toggle(VISUAL_REFRESH_CLASSNAME, true);
  }
  if (weblabs.includes('SP_SERVICES_KATAL_810944=T1')) {
    Object.values(WEBLAB_IDS).forEach(weblab => {
      document.body?.classList.add(weblab);
    });
  } else {
    weblabs.forEach(weblab => {
      const parsedWeblabName = weblab.replace('=', '_');
      document.body?.classList.add(parsedWeblabName);
    });
  }
};
export const convertWeblabMetaElementOnceWhenDomReady = () => {
  if (window['KATAL_CONVERT_WEBLAB_META_ELEMENT_EXECUTED']) {
    return;
  }
  window['KATAL_CONVERT_WEBLAB_META_ELEMENT_EXECUTED'] = true;
  domReady(convertWeblabMetaElement);
};
const attachVisualRefreshCSS = () => {
  document.body?.classList.toggle(VISUAL_REFRESH_CLASSNAME, true);
};
export const attachVisualRefreshCSSOnceWhenDomReady = () => {
  if (window['KATAL_ATTACH_VISUAL_REFRESH']) {
    return;
  }
  window['KATAL_ATTACH_VISUAL_REFRESH'] = true;
  domReady(attachVisualRefreshCSS);
};
const weblabClassChangeCallbacks = new Set();
const includesWeblabClass = classList => {
  if (!classList) {
    return false;
  }
  return Object.values(WEBLAB_IDS).some(weblabClass => classList.includes(weblabClass)) || classList.includes(VISUAL_REFRESH_CLASSNAME);
};
const notifyBodyWeblabClassChange = mutations => {
  mutations.forEach(mutation => {
    const currBodyClassList = Array.from(mutation.target.classList);
    const prevBodyClassList = mutation.oldValue?.split(' ');
    const weblabClassAddedOrRemoved = includesWeblabClass(prevBodyClassList) || includesWeblabClass(currBodyClassList);
    if (weblabClassAddedOrRemoved) {
      weblabClassChangeCallbacks.forEach(cb => cb());
    }
  });
};
const observer = new MutationObserver(notifyBodyWeblabClassChange);
let observing = false;
export const onBodyWeblabClassChange = cb => {
  weblabClassChangeCallbacks.add(cb);
  if (!observing) {
    observing = true;
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });
  }
};
export const offBodyWeblabClassChange = cb => {
  weblabClassChangeCallbacks.delete(cb);
  if (observing) {
    observing = false;
    observer.disconnect();
  }
};
//# sourceMappingURL=weblab-helpers.js.map